export const state = () => ({
  state: 'Стейт',
})
